<template>
    <MasterTemplate 
            title="ข้อมูลผู้ใช้งาน" 
            :headers="headers" 
            itemKey="userId"
            :setData="setData"
            :getItemName="getItemName"
            :deleteData="deleteData"
            :insertData="insertData"
            :updateData="updateData"
            :listData="listData"
            >

            <template v-slot:formInput="{ editedIndex , rules}">
                <v-row v-if="editedIndex == -1">
                    <v-col cols="6">
                        <v-text-field maxlength="25" v-model="editedItem.username" autofocus label="ชื่อผู้ใช้" :rules="[rules.required, chkUser]"></v-text-field>
                    </v-col>
                    <v-col cols="6" >
                        <v-text-field v-model="editedItem.password" label="password" :rules="[rules.required]"></v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="6" >
                        <v-text-field maxlength="100" v-model="editedItem.firstName" label="ชื่อ" :rules="[rules.required]"></v-text-field>
                    </v-col>
                    <v-col cols="6" >
                        <v-text-field maxlength="100" v-model="editedItem.lastName" label="นามสกุล" :rules="[rules.required]"></v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="6">
                        <v-text-field maxlength="50" v-model="editedItem.email" label="email" :rules="[rules.required, chkEmail]"></v-text-field>
                    </v-col>
                     <v-col cols="6">
                        <v-text-field maxlength="200" v-model="editedItem.position" label="position" ></v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="6">
                        <v-checkbox  v-model="editedItem.superUser" label="SuperUser (สามารถเข้าระบบจัดการสิทธ์ได้)"></v-checkbox>
                    </v-col>
                </v-row>
        </template>
    </MasterTemplate>
</template>

<script>
/* eslint-disable */
import MasterTemplate from '@/components/MasterTemplate'
import {list, isExistUser, isExistEmail, insert, update, deleteUser} from '@/api/master/user-api.js'

export default {
    name: 'User',
    components: {
        MasterTemplate
    },
    data: () => ({
        headers: [
            {text: 'ชื่อผู้ใช้', value: 'username'},
            {text: 'ชื่อ-นามสกุล', value: 'fullname'},
            {text: 'email', value: 'email'},
            {text: 'position', value: 'position'},
            {text: 'Actions', value: 'action', sortable: false}
        ],
        desserts: [],
        editedItem: {
            userId: '-1',
            username: '',
            firstName: '',
            lastName: '',
            email: '',
            fullname: '',
            position: '',
            superUser: false
        },
        isEditMode: false,
        isExistUser: false,
        isExistEmail: false
    }),
    computed: {
        chkUser() {
            if (this.isExistUser == true) return 'ชื่อผู้ใช้ซ้ำ';
            return true;
        },
        chkEmail() {
            if (this.isExistEmail == true) return 'email ซ้ำ';
            return true;
        }
    },
    watch: {
        'editedItem.firstName': function(newVal, oldVal) {
            this.editedItem.fullname = newVal + ' ' + this.editedItem.lastName;
        },
        'editedItem.lastName': function(newVal, oldVal) {
            this.editedItem.fullname = this.editedItem.firstName + ' ' + newVal;
        },
        'editedItem.username': function(newVal, oldVal) {
            if (!this.editedItem.userId) {
                this.editedItem.userId = '-1';
            }
            if (newVal && this.editedItem.userId) {
                isExistUser(newVal, this.editedItem.userId).then(response => {
                    this.isExistUser = response;
                }).catch(e => {
                    this.isExistUser = false;
                });
            }
        },
        'editedItem.email': function(newVal, oldVal) {
            if (!this.editedItem.userId) {
                this.editedItem.userId = '-1';
            }
            if (newVal && this.editedItem.userId) {
                isExistEmail(newVal, this.editedItem.userId).then(response => {
                    this.isExistEmail = response.data;
                }).catch(e => {
                    this.isExistEmail = false;
                });
            }
        }
    },
    methods: {
        listData() {
            return list();
        },
        deleteData(item) {
            return deleteUser(item.userId);
        },
        insertData() {
            return insert(this.editedItem);
        },
        updateData() {
            return update(this.editedItem);
        },
        getItemName(item) {
            return item.username;
        },
        setData(item) {
            this.editedItem = item;
        }
    }
};
</script>